/**
 * Function to capitalize the first letter of a given string.
 * This function is a utility function commonly used across the application
 * wherever the first letter of a string needs to be capitalized.
 *
 * @param {string} string - The string whose first letter needs to be capitalized.
 *
 * @returns {string} - Returns the string with its first letter capitalized.
 */
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
